// @ts-nocheck
import { RHFCode } from "./rhf-code";
import { RHFRating } from "./rhf-rating";
import { RHFEditor } from "./rhf-editor";
import { RHFSlider } from "./rhf-slider";
import { RHFTextField } from "./rhf-text-field";
import { RHFRadioGroup } from "./rhf-radio-group";
import { RHFPhoneInput } from "./rhf-phone-input";
import { RHFAutocomplete } from "./rhf-autocomplete";
import { RHFCountrySelect } from "./rhf-country-select";
import { RHFSwitch, RHFMultiSwitch } from "./rhf-switch";
import { RHFSelect, RHFMultiSelect } from "./rhf-select";
import { RHFCheckbox, RHFMultiCheckbox } from "./rhf-checkbox";
import { RHFUpload, RHFUploadBox, RHFUploadAvatar } from "./rhf-upload";
import {
  RHFDatePicker,
  RHFDateTimePicker,
  RHFMobileDateTimePicker,
  RHFTimePicker,
} from "./rhf-date-picker";

// ----------------------------------------------------------------------

export const Field = {
  Code: RHFCode,
  Editor: RHFEditor,
  Select: RHFSelect,
  Upload: RHFUpload,
  Switch: RHFSwitch,
  Slider: RHFSlider,
  Rating: RHFRating,
  Text: RHFTextField,
  Phone: RHFPhoneInput,
  Checkbox: RHFCheckbox,
  UploadBox: RHFUploadBox,
  RadioGroup: RHFRadioGroup,
  DatePicker: RHFDatePicker,
  DateTimePicker: RHFDateTimePicker,
  TimePicker: RHFTimePicker,
  MultiSelect: RHFMultiSelect,
  MultiSwitch: RHFMultiSwitch,
  UploadAvatar: RHFUploadAvatar,
  Autocomplete: RHFAutocomplete,
  MultiCheckbox: RHFMultiCheckbox,
  CountrySelect: RHFCountrySelect,
  MobileDateTimePicker: RHFMobileDateTimePicker,
};
